<template>
    <div>
        <Modal v-model="isshowLogin" :closable="false" :footer-hide="true" :mask-closable="false" class-name="sel_login_big">
            <div class="sel_login">
                <div class="title">{{$t('m.Welcome_log_in')}}</div>
                <span class="close" @click="close"></span>

                <div class="from">
                    <Input :clearable='true' type='email' :autofocus='true' v-model="email" class="sel_login_input" size="large" :placeholder="$t('m.email')"/>
                    <Input :clearable='true' type='password' v-model="password" class="sel_login_input" size="large" :placeholder="$t('m.password')" />
                </div>

                <div class="bottom_button">
                    <Button type="primary" size="large" @click="login">{{$t('m.log_in')}}</Button>
                    <span class="sel_login_wjmm">{{$t('m.forget_password')}}</span>
                    <span class="sel_login_wjmm sel_ljzc" @click='regiButt'>{{$t('m.Immediate_registration')}}</span>
                </div>

                <div class="xian">
                    <span>{{$t('m.Sign_in_with')}}</span>
                    <div class="login_type">
                        <em>
                            <img src="../../assets/facebook_icon.png" alt="">
                            <b>Facebook</b>
                        </em>
                        <em>
                            <img src="../../assets/twitter_icon.png" alt="">
                            <b>Twitter</b>
                        </em>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data(){
        return {
            email:'',
            password:''
        }
    },
    methods:{
         //登录
        login(){
            const vm = this;
            const resData = vm.Init('login');
            resData.mailbox = vm.email;
            resData.password = vm.md5(vm.password);
            resData.uuid = vm.userId;  //未登录用户id
            vm.yzInput(resData,(msg)=>{
                if(!msg){
                    vm.Req(resData,res=>{
                        if(res.ret=='1'){
                            vm.login_succ()
                            vm.$store.setLoginAction(1,res.params)
                            // vm.isshowLogin = false;
                            vm.storageLocal(res.params);
                            vm.email = '';
                            vm.password = '';
                            if(vm.operation_type == '0'){
                                vm.pay()
                            }
                        }else{
                            vm.$Message.error(res.msg);
                        }
                    })      
                }else{
                    vm.$Message.error(msg);
                }
            })
        },
        //验证登录注册输入内容
        yzInput(obj,callback){
            const vm = this;
            if(!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(obj.mailbox)){
                callback(vm.$t('m.Email_incorrect'));
                return
            }
            if((vm.password.length<6)||(vm.password.length>16)){
                callback(vm.$t('m.Password_incorrect'));
                return
            }
            callback(false)
        }
        
    },
    props:{
        isshowLogin:{
            type:Boolean,
            default:false
        },
        login_succ:{ //登录成功执行的回掉
            type:Function,
            default:()=>{}
        },
        close:{
            type:Function,
            default:()=>{}
        },
        regiButt:{
            type:Function,
            default:()=>{}
        }
    }
}
</script>

<style>
    .sel_login{padding:40px;position: relative;}
    .sel_login .title{color:#5a5959;font-size:23px;}
    .sel_login .close{width:30px;height:30px;background: url("../../assets/login_close.png") no-repeat 0/100%;display:inline-block;position:absolute;right:40px;top:42px;cursor: pointer;}
    .sel_login .login_icon{margin-top:20px;}
    .sel_login .login_icon .icon{display:inline-block;width:50%;text-align: center;margin-top:5px;cursor: pointer;}
    .sel_login .login_icon .icon img{padding:10px;}
    .sel_login .login_icon .icon b{display:block;font-size:18px;color:#8e8e8e;font-weight:normal;}

    .sel_login .from{margin:35px 0 5px;}
    .sel_login .from .sel_login_input{margin-bottom:25px;}
    .sel_login .bottom_button{text-align: right;}
    .sel_login .bottom_button button{width: 100%;height:45px;}
    .sel_login .bottom_button .sel_login_wjmm{font-size:14px;color:#666;text-align: right; display:inline-block;margin-top:12px;cursor: pointer;}
    .sel_login .bottom_button .sel_login_wjmm.sel_ljzc{float:left;display:block;}
    .xian{border-top:1px solid #d2d2d2;text-align: center;margin-top:25px;}
    .xian span{display:inline-block;font-size:13px;color:#939393;position:relative;top:-10px;background:#fff;padding:0 20px;}
    .login_type{margin-top:10px;}
    .login_type em{display: inline-block;width:50%;height:35px;line-height:35px;cursor: pointer;}
    .login_type em img{height:100%;margin-right:5px;}
    .login_type em b{font-weight: normal;color:#939393;}
    .sel_login{padding-bottom:30px;}

</style>
